var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalDesignIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 4,
    height: 4,
    transform: "translate(-0.429 -0.268)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(-1387 -402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    transform: "translate(1387 402)",
    fill: "none",
    stroke: "#323232",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 36.5,
    height: 46.5,
    rx: 3.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c7b5d585cf3a23aadf886f0fb53b2da1",
    transform: "translate(1392.279 411.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M18.772,21.813a.432.432,0,0,0,.222.059.451.451,0,0,0,.244-.074l4.355-2.733a.462.462,0,0,0,.214-.4.447.447,0,0,0-.244-.369l-4.351-2.345a.454.454,0,0,0-.451,0,.447.447,0,0,0-.222.392V21.4a.451.451,0,0,0,.233.414Zm.676-4.7,2.988,1.6-2.988,1.876Z",
    transform: "translate(-6.836 -5.164)",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M13.72,19.741A6.02,6.02,0,1,0,7.7,13.72,6.02,6.02,0,0,0,13.72,19.741Zm0-11.129A5.108,5.108,0,1,1,8.612,13.72,5.108,5.108,0,0,1,13.72,8.612Z",
    fill: "#323232"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upper_part",
    "data-name": "upper part",
    transform: "translate(2.055 2.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e532337be0eb4cfa3f3d5068bc5f15fd",
    transform: "translate(1389 404.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M0,0H3.751V3.751H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M9.25,2.625V2l-.781.781.781.781V2.938a.938.938,0,1,1-.938.938H8a1.25,1.25,0,1,0,1.25-1.25Z",
    transform: "translate(-7.375 -1.844)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 18.461,
    transform: "translate(1394.714 406.198)",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "_64514108c303f0def8f31758cee0e240",
    "data-name": "64514108c303f0def8f31758cee0e240",
    transform: "translate(1415.374 404)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M3.19,8.8h.5a.172.172,0,0,1,.106.044l.569.569c.073.073.132.048.132-.055V7c0-.1-.059-.127-.132-.055l-.569.569a.172.172,0,0,1-.106.044h-.5A.186.186,0,0,0,3,7.747v.869A.186.186,0,0,0,3.19,8.8Z",
    transform: "translate(-2.851 -6.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M37.394,3.526h0a1.33,1.33,0,0,0-.254-.782,1.368,1.368,0,0,0-.649-.486l-.059-.021a.062.062,0,0,1-.038-.079l.042-.117A.062.062,0,0,1,36.516,2l.058.021a1.615,1.615,0,0,1,.767.574,1.58,1.58,0,0,1,.3.928h0a1.579,1.579,0,0,1-.3.927,1.617,1.617,0,0,1-.767.574l-.058.021a.062.062,0,0,1-.079-.038L36.4,4.893a.062.062,0,0,1,.038-.079l.059-.021a1.368,1.368,0,0,0,.649-.486A1.33,1.33,0,0,0,37.394,3.526Zm.248,0Zm0,0",
    transform: "translate(-34.541 -1.637)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M36.4,14.693l-.056-.028a.062.062,0,0,1-.028-.083l.056-.111a.062.062,0,0,1,.083-.027l.055.028a1.061,1.061,0,0,1,.4.352.9.9,0,0,1,0,1.013,1.062,1.062,0,0,1-.4.352l-.055.028a.062.062,0,0,1-.083-.027l-.056-.111a.062.062,0,0,1,.028-.083l.056-.028a.818.818,0,0,0,.307-.269.652.652,0,0,0,0-.734A.813.813,0,0,0,36.4,14.693Z",
    transform: "translate(-34.466 -13.44)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1396.945 404.732)",
    fill: "#323232"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalDesignIcon);
export default __webpack_public_path__ + "static/media/modalDesignIcon.8ea87a34d5948d9d901fe13f2fa95cc6.svg";
export { ForwardRef as ReactComponent };